type FontAwesomeIcon = ILabelValue & { type: "fas" };

export const FONT_AWESOME_ICONS: FontAwesomeIcon[] = [
    {
        label: "0",
        value: "0",
        type: "fas",
    },
    {
        label: "1",
        value: "1",
        type: "fas",
    },
    {
        label: "2",
        value: "2",
        type: "fas",
    },
    {
        label: "3",
        value: "3",
        type: "fas",
    },
    {
        label: "4",
        value: "4",
        type: "fas",
    },
    {
        label: "5",
        value: "5",
        type: "fas",
    },
    {
        label: "6",
        value: "6",
        type: "fas",
    },
    {
        label: "7",
        value: "7",
        type: "fas",
    },
    {
        label: "8",
        value: "8",
        type: "fas",
    },
    {
        label: "9",
        value: "9",
        type: "fas",
    },
    {
        label: "A",
        value: "a",
        type: "fas",
    },
    {
        label: "Align Center",
        value: "align-center",
        type: "fas",
    },
    {
        label: "Align Justify",
        value: "align-justify",
        type: "fas",
    },
    {
        label: "Align Left",
        value: "align-left",
        type: "fas",
    },
    {
        label: "Align Right",
        value: "align-right",
        type: "fas",
    },
    {
        label: "Anchor",
        value: "anchor",
        type: "fas",
    },
    {
        label: "Angle Down",
        value: "angle-down",
        type: "fas",
    },
    {
        label: "Angle Left",
        value: "angle-left",
        type: "fas",
    },
    {
        label: "Angle Right",
        value: "angle-right",
        type: "fas",
    },
    {
        label: "Angles Down",
        value: "angles-down",
        type: "fas",
    },
    {
        label: "Angles Left",
        value: "angles-left",
        type: "fas",
    },
    {
        label: "Angles Right",
        value: "angles-right",
        type: "fas",
    },
    {
        label: "Angles Up",
        value: "angles-up",
        type: "fas",
    },
    {
        label: "Angle Up",
        value: "angle-up",
        type: "fas",
    },
    {
        label: "Ankh",
        value: "ankh",
        type: "fas",
    },
    {
        label: "Apple Whole",
        value: "apple-whole",
        type: "fas",
    },
    {
        label: "Archway",
        value: "archway",
        type: "fas",
    },
    {
        label: "Arrow Down",
        value: "arrow-down",
        type: "fas",
    },
    {
        label: "Arrow Down A Z",
        value: "arrow-down-a-z",
        type: "fas",
    },
    {
        label: "Arrow Down Long",
        value: "arrow-down-long",
        type: "fas",
    },
    {
        label: "Arrow Down Short Wide",
        value: "arrow-down-short-wide",
        type: "fas",
    },
    {
        label: "Arrow Down Wide Short",
        value: "arrow-down-wide-short",
        type: "fas",
    },
    {
        label: "Arrow Down Z A",
        value: "arrow-down-z-a",
        type: "fas",
    },
    {
        label: "Arrow Left",
        value: "arrow-left",
        type: "fas",
    },
    {
        label: "Arrow Left Long",
        value: "arrow-left-long",
        type: "fas",
    },
    {
        label: "Arrow Pointer",
        value: "arrow-pointer",
        type: "fas",
    },
    {
        label: "Arrow Right",
        value: "arrow-right",
        type: "fas",
    },
    {
        label: "Arrow Right Arrow Left",
        value: "arrow-right-arrow-left",
        type: "fas",
    },
    {
        label: "Arrow Right From Bracket",
        value: "arrow-right-from-bracket",
        type: "fas",
    },
    {
        label: "Arrow Right Long",
        value: "arrow-right-long",
        type: "fas",
    },
    {
        label: "Arrow Right To Bracket",
        value: "arrow-right-to-bracket",
        type: "fas",
    },
    {
        label: "Arrow Rotate Left",
        value: "arrow-rotate-left",
        type: "fas",
    },
    {
        label: "Arrow Rotate Right",
        value: "arrow-rotate-right",
        type: "fas",
    },
    {
        label: "Arrows Left Right",
        value: "arrows-left-right",
        type: "fas",
    },
    {
        label: "Arrows Rotate",
        value: "arrows-rotate",
        type: "fas",
    },
    {
        label: "Arrows Up Down",
        value: "arrows-up-down",
        type: "fas",
    },
    {
        label: "Arrows Up Down Left Right",
        value: "arrows-up-down-left-right",
        type: "fas",
    },
    {
        label: "Arrow Trend Down",
        value: "arrow-trend-down",
        type: "fas",
    },
    {
        label: "Arrow Trend Up",
        value: "arrow-trend-up",
        type: "fas",
    },
    {
        label: "Arrow Turn Down",
        value: "arrow-turn-down",
        type: "fas",
    },
    {
        label: "Arrow Turn Up",
        value: "arrow-turn-up",
        type: "fas",
    },
    {
        label: "Arrow Up",
        value: "arrow-up",
        type: "fas",
    },
    {
        label: "Arrow Up A Z",
        value: "arrow-up-a-z",
        type: "fas",
    },
    {
        label: "Arrow Up From Bracket",
        value: "arrow-up-from-bracket",
        type: "fas",
    },
    {
        label: "Arrow Up Long",
        value: "arrow-up-long",
        type: "fas",
    },
    {
        label: "Arrow Up Right From Square",
        value: "arrow-up-right-from-square",
        type: "fas",
    },
    {
        label: "Arrow Up Short Wide",
        value: "arrow-up-short-wide",
        type: "fas",
    },
    {
        label: "Arrow Up Wide Short",
        value: "arrow-up-wide-short",
        type: "fas",
    },
    {
        label: "Arrow Up Z A",
        value: "arrow-up-z-a",
        type: "fas",
    },
    {
        label: "Asterisk",
        value: "asterisk",
        type: "fas",
    },
    {
        label: "At",
        value: "at",
        type: "fas",
    },
    {
        label: "Atom",
        value: "atom",
        type: "fas",
    },
    {
        label: "Audio Description",
        value: "audio-description",
        type: "fas",
    },
    {
        label: "Austral Sign",
        value: "austral-sign",
        type: "fas",
    },
    {
        label: "Award",
        value: "award",
        type: "fas",
    },
    {
        label: "B",
        value: "b",
        type: "fas",
    },
    {
        label: "Baby",
        value: "baby",
        type: "fas",
    },
    {
        label: "Baby Carriage",
        value: "baby-carriage",
        type: "fas",
    },
    {
        label: "Backward",
        value: "backward",
        type: "fas",
    },
    {
        label: "Backward Fast",
        value: "backward-fast",
        type: "fas",
    },
    {
        label: "Backward Step",
        value: "backward-step",
        type: "fas",
    },
    {
        label: "Bacon",
        value: "bacon",
        type: "fas",
    },
    {
        label: "Bacteria",
        value: "bacteria",
        type: "fas",
    },
    {
        label: "Bacterium",
        value: "bacterium",
        type: "fas",
    },
    {
        label: "Bag Shopping",
        value: "bag-shopping",
        type: "fas",
    },
    {
        label: "Bahai",
        value: "bahai",
        type: "fas",
    },
    {
        label: "Baht Sign",
        value: "baht-sign",
        type: "fas",
    },
    {
        label: "Ban",
        value: "ban",
        type: "fas",
    },
    {
        label: "Bandage",
        value: "bandage",
        type: "fas",
    },
    {
        label: "Ban Smoking",
        value: "ban-smoking",
        type: "fas",
    },
    {
        label: "Barcode",
        value: "barcode",
        type: "fas",
    },
    {
        label: "Bars",
        value: "bars",
        type: "fas",
    },
    {
        label: "Bars Progress",
        value: "bars-progress",
        type: "fas",
    },
    {
        label: "Bars Staggered",
        value: "bars-staggered",
        type: "fas",
    },
    {
        label: "Baseball",
        value: "baseball",
        type: "fas",
    },
    {
        label: "Basketball",
        value: "basketball",
        type: "fas",
    },
    {
        label: "Basket Shopping",
        value: "basket-shopping",
        type: "fas",
    },
    {
        label: "Bath",
        value: "bath",
        type: "fas",
    },
    {
        label: "Battery Empty",
        value: "battery-empty",
        type: "fas",
    },
    {
        label: "Battery Full",
        value: "battery-full",
        type: "fas",
    },
    {
        label: "Battery Half",
        value: "battery-half",
        type: "fas",
    },
    {
        label: "Battery Quarter",
        value: "battery-quarter",
        type: "fas",
    },
    {
        label: "Battery Three Quarters",
        value: "battery-three-quarters",
        type: "fas",
    },
    {
        label: "Bed",
        value: "bed",
        type: "fas",
    },
    {
        label: "Bed Pulse",
        value: "bed-pulse",
        type: "fas",
    },
    {
        label: "Beer Mug Empty",
        value: "beer-mug-empty",
        type: "fas",
    },
    {
        label: "Bell Concierge",
        value: "bell-concierge",
        type: "fas",
    },
    {
        label: "Bezier Curve",
        value: "bezier-curve",
        type: "fas",
    },
    {
        label: "Bicycle",
        value: "bicycle",
        type: "fas",
    },
    {
        label: "Binoculars",
        value: "binoculars",
        type: "fas",
    },
    {
        label: "Biohazard",
        value: "biohazard",
        type: "fas",
    },
    {
        label: "Bitcoin Sign",
        value: "bitcoin-sign",
        type: "fas",
    },
    {
        label: "Blender",
        value: "blender",
        type: "fas",
    },
    {
        label: "Blender Phone",
        value: "blender-phone",
        type: "fas",
    },
    {
        label: "Blog",
        value: "blog",
        type: "fas",
    },
    {
        label: "Bold",
        value: "bold",
        type: "fas",
    },
    {
        label: "Bolt",
        value: "bolt",
        type: "fas",
    },
    {
        label: "Bomb",
        value: "bomb",
        type: "fas",
    },
    {
        label: "Bone",
        value: "bone",
        type: "fas",
    },
    {
        label: "Bong",
        value: "bong",
        type: "fas",
    },
    {
        label: "Book",
        value: "book",
        type: "fas",
    },
    {
        label: "Book Atlas",
        value: "book-atlas",
        type: "fas",
    },
    {
        label: "Book Bible",
        value: "book-bible",
        type: "fas",
    },
    {
        label: "Book Journal Whills",
        value: "book-journal-whills",
        type: "fas",
    },
    {
        label: "Book Medical",
        value: "book-medical",
        type: "fas",
    },
    {
        label: "Book Open",
        value: "book-open",
        type: "fas",
    },
    {
        label: "Book Open Reader",
        value: "book-open-reader",
        type: "fas",
    },
    {
        label: "Book Quran",
        value: "book-quran",
        type: "fas",
    },
    {
        label: "Book Skull",
        value: "book-skull",
        type: "fas",
    },
    {
        label: "Border All",
        value: "border-all",
        type: "fas",
    },
    {
        label: "Border None",
        value: "border-none",
        type: "fas",
    },
    {
        label: "Border Top Left",
        value: "border-top-left",
        type: "fas",
    },
    {
        label: "Bowling Ball",
        value: "bowling-ball",
        type: "fas",
    },
    {
        label: "Box",
        value: "box",
        type: "fas",
    },
    {
        label: "Box Archive",
        value: "box-archive",
        type: "fas",
    },
    {
        label: "Boxes Stacked",
        value: "boxes-stacked",
        type: "fas",
    },
    {
        label: "Box Open",
        value: "box-open",
        type: "fas",
    },
    {
        label: "Box Tissue",
        value: "box-tissue",
        type: "fas",
    },
    {
        label: "Braille",
        value: "braille",
        type: "fas",
    },
    {
        label: "Brain",
        value: "brain",
        type: "fas",
    },
    {
        label: "Brazilian Real Sign",
        value: "brazilian-real-sign",
        type: "fas",
    },
    {
        label: "Bread Slice",
        value: "bread-slice",
        type: "fas",
    },
    {
        label: "Briefcase",
        value: "briefcase",
        type: "fas",
    },
    {
        label: "Briefcase Medical",
        value: "briefcase-medical",
        type: "fas",
    },
    {
        label: "Broom",
        value: "broom",
        type: "fas",
    },
    {
        label: "Broom Ball",
        value: "broom-ball",
        type: "fas",
    },
    {
        label: "Brush",
        value: "brush",
        type: "fas",
    },
    {
        label: "Bug",
        value: "bug",
        type: "fas",
    },
    {
        label: "Bullhorn",
        value: "bullhorn",
        type: "fas",
    },
    {
        label: "Bullseye",
        value: "bullseye",
        type: "fas",
    },
    {
        label: "Burger",
        value: "burger",
        type: "fas",
    },
    {
        label: "Bus",
        value: "bus",
        type: "fas",
    },
    {
        label: "Business Time",
        value: "business-time",
        type: "fas",
    },
    {
        label: "Bus Simple",
        value: "bus-simple",
        type: "fas",
    },
    {
        label: "C",
        value: "c",
        type: "fas",
    },
    {
        label: "Cake Candles",
        value: "cake-candles",
        type: "fas",
    },
    {
        label: "Calculator",
        value: "calculator",
        type: "fas",
    },
    {
        label: "Calendar Day",
        value: "calendar-day",
        type: "fas",
    },
    {
        label: "Calendar Week",
        value: "calendar-week",
        type: "fas",
    },
    {
        label: "Camera",
        value: "camera",
        type: "fas",
    },
    {
        label: "Camera Retro",
        value: "camera-retro",
        type: "fas",
    },
    {
        label: "Camera Rotate",
        value: "camera-rotate",
        type: "fas",
    },
    {
        label: "Campground",
        value: "campground",
        type: "fas",
    },
    {
        label: "Candy Cane",
        value: "candy-cane",
        type: "fas",
    },
    {
        label: "Cannabis",
        value: "cannabis",
        type: "fas",
    },
    {
        label: "Capsules",
        value: "capsules",
        type: "fas",
    },
    {
        label: "Car",
        value: "car",
        type: "fas",
    },
    {
        label: "Caravan",
        value: "caravan",
        type: "fas",
    },
    {
        label: "Car Battery",
        value: "car-battery",
        type: "fas",
    },
    {
        label: "Caret Down",
        value: "caret-down",
        type: "fas",
    },
    {
        label: "Caret Left",
        value: "caret-left",
        type: "fas",
    },
    {
        label: "Caret Right",
        value: "caret-right",
        type: "fas",
    },
    {
        label: "Caret Up",
        value: "caret-up",
        type: "fas",
    },
    {
        label: "Car Rear",
        value: "car-rear",
        type: "fas",
    },
    {
        label: "Carrot",
        value: "carrot",
        type: "fas",
    },
    {
        label: "Car Side",
        value: "car-side",
        type: "fas",
    },
    {
        label: "Cart Arrow Down",
        value: "cart-arrow-down",
        type: "fas",
    },
    {
        label: "Cart Flatbed",
        value: "cart-flatbed",
        type: "fas",
    },
    {
        label: "Cart Flatbed Suitcase",
        value: "cart-flatbed-suitcase",
        type: "fas",
    },
    {
        label: "Cart Plus",
        value: "cart-plus",
        type: "fas",
    },
    {
        label: "Cart Shopping",
        value: "cart-shopping",
        type: "fas",
    },
    {
        label: "Cash Register",
        value: "cash-register",
        type: "fas",
    },
    {
        label: "Cat",
        value: "cat",
        type: "fas",
    },
    {
        label: "Cedi Sign",
        value: "cedi-sign",
        type: "fas",
    },
    {
        label: "Cent Sign",
        value: "cent-sign",
        type: "fas",
    },
    {
        label: "Certificate",
        value: "certificate",
        type: "fas",
    },
    {
        label: "Chair",
        value: "chair",
        type: "fas",
    },
    {
        label: "Chalkboard",
        value: "chalkboard",
        type: "fas",
    },
    {
        label: "Chalkboard User",
        value: "chalkboard-user",
        type: "fas",
    },
    {
        label: "Champagne Glasses",
        value: "champagne-glasses",
        type: "fas",
    },
    {
        label: "Charging Station",
        value: "charging-station",
        type: "fas",
    },
    {
        label: "Chart Area",
        value: "chart-area",
        type: "fas",
    },
    {
        label: "Chart Column",
        value: "chart-column",
        type: "fas",
    },
    {
        label: "Chart Gantt",
        value: "chart-gantt",
        type: "fas",
    },
    {
        label: "Chart Line",
        value: "chart-line",
        type: "fas",
    },
    {
        label: "Chart Pie",
        value: "chart-pie",
        type: "fas",
    },
    {
        label: "Check",
        value: "check",
        type: "fas",
    },
    {
        label: "Check Double",
        value: "check-double",
        type: "fas",
    },
    {
        label: "Check To Slot",
        value: "check-to-slot",
        type: "fas",
    },
    {
        label: "Cheese",
        value: "cheese",
        type: "fas",
    },
    {
        label: "Chess",
        value: "chess",
        type: "fas",
    },
    {
        label: "Chess Board",
        value: "chess-board",
        type: "fas",
    },
    {
        label: "Chevron Down",
        value: "chevron-down",
        type: "fas",
    },
    {
        label: "Chevron Left",
        value: "chevron-left",
        type: "fas",
    },
    {
        label: "Chevron Right",
        value: "chevron-right",
        type: "fas",
    },
    {
        label: "Chevron Up",
        value: "chevron-up",
        type: "fas",
    },
    {
        label: "Child",
        value: "child",
        type: "fas",
    },
    {
        label: "Church",
        value: "church",
        type: "fas",
    },
    {
        label: "Circle Arrow Down",
        value: "circle-arrow-down",
        type: "fas",
    },
    {
        label: "Circle Arrow Left",
        value: "circle-arrow-left",
        type: "fas",
    },
    {
        label: "Circle Arrow Right",
        value: "circle-arrow-right",
        type: "fas",
    },
    {
        label: "Circle Arrow Up",
        value: "circle-arrow-up",
        type: "fas",
    },
    {
        label: "Circle Chevron Down",
        value: "circle-chevron-down",
        type: "fas",
    },
    {
        label: "Circle Chevron Left",
        value: "circle-chevron-left",
        type: "fas",
    },
    {
        label: "Circle Chevron Right",
        value: "circle-chevron-right",
        type: "fas",
    },
    {
        label: "Circle Chevron Up",
        value: "circle-chevron-up",
        type: "fas",
    },
    {
        label: "Circle Dollar To Slot",
        value: "circle-dollar-to-slot",
        type: "fas",
    },
    {
        label: "Circle Exclamation",
        value: "circle-exclamation",
        type: "fas",
    },
    {
        label: "Circle H",
        value: "circle-h",
        type: "fas",
    },
    {
        label: "Circle Half Stroke",
        value: "circle-half-stroke",
        type: "fas",
    },
    {
        label: "Circle Info",
        value: "circle-info",
        type: "fas",
    },
    {
        label: "Circle Minus",
        value: "circle-minus",
        type: "fas",
    },
    {
        label: "Circle Notch",
        value: "circle-notch",
        type: "fas",
    },
    {
        label: "Circle Plus",
        value: "circle-plus",
        type: "fas",
    },
    {
        label: "Circle Radiation",
        value: "circle-radiation",
        type: "fas",
    },
    {
        label: "City",
        value: "city",
        type: "fas",
    },
    {
        label: "Clapperboard",
        value: "clapperboard",
        type: "fas",
    },
    {
        label: "Clipboard",
        value: "clipboard",
        type: "fas",
    },
    {
        label: "Clipboard Check",
        value: "clipboard-check",
        type: "fas",
    },
    {
        label: "Clipboard List",
        value: "clipboard-list",
        type: "fas",
    },
    {
        label: "Clock Rotate Left",
        value: "clock-rotate-left",
        type: "fas",
    },
    {
        label: "Cloud",
        value: "cloud",
        type: "fas",
    },
    {
        label: "Cloud Arrow Down",
        value: "cloud-arrow-down",
        type: "fas",
    },
    {
        label: "Cloud Arrow Up",
        value: "cloud-arrow-up",
        type: "fas",
    },
    {
        label: "Cloud Meatball",
        value: "cloud-meatball",
        type: "fas",
    },
    {
        label: "Cloud Moon",
        value: "cloud-moon",
        type: "fas",
    },
    {
        label: "Cloud Moon Rain",
        value: "cloud-moon-rain",
        type: "fas",
    },
    {
        label: "Cloud Rain",
        value: "cloud-rain",
        type: "fas",
    },
    {
        label: "Cloud Showers Heavy",
        value: "cloud-showers-heavy",
        type: "fas",
    },
    {
        label: "Cloud Sun",
        value: "cloud-sun",
        type: "fas",
    },
    {
        label: "Cloud Sun Rain",
        value: "cloud-sun-rain",
        type: "fas",
    },
    {
        label: "Clover",
        value: "clover",
        type: "fas",
    },
    {
        label: "Code",
        value: "code",
        type: "fas",
    },
    {
        label: "Code Branch",
        value: "code-branch",
        type: "fas",
    },
    {
        label: "Code Commit",
        value: "code-commit",
        type: "fas",
    },
    {
        label: "Code Compare",
        value: "code-compare",
        type: "fas",
    },
    {
        label: "Code Fork",
        value: "code-fork",
        type: "fas",
    },
    {
        label: "Code Merge",
        value: "code-merge",
        type: "fas",
    },
    {
        label: "Code Pull Request",
        value: "code-pull-request",
        type: "fas",
    },
    {
        label: "Coins",
        value: "coins",
        type: "fas",
    },
    {
        label: "Colon Sign",
        value: "colon-sign",
        type: "fas",
    },
    {
        label: "Comment Dollar",
        value: "comment-dollar",
        type: "fas",
    },
    {
        label: "Comment Medical",
        value: "comment-medical",
        type: "fas",
    },
    {
        label: "Comments Dollar",
        value: "comments-dollar",
        type: "fas",
    },
    {
        label: "Comment Slash",
        value: "comment-slash",
        type: "fas",
    },
    {
        label: "Comment Sms",
        value: "comment-sms",
        type: "fas",
    },
    {
        label: "Compact Disc",
        value: "compact-disc",
        type: "fas",
    },
    {
        label: "Compass Drafting",
        value: "compass-drafting",
        type: "fas",
    },
    {
        label: "Compress",
        value: "compress",
        type: "fas",
    },
    {
        label: "Computer Mouse",
        value: "computer-mouse",
        type: "fas",
    },
    {
        label: "Cookie",
        value: "cookie",
        type: "fas",
    },
    {
        label: "Cookie Bite",
        value: "cookie-bite",
        type: "fas",
    },
    {
        label: "Couch",
        value: "couch",
        type: "fas",
    },
    {
        label: "Crop",
        value: "crop",
        type: "fas",
    },
    {
        label: "Crop Simple",
        value: "crop-simple",
        type: "fas",
    },
    {
        label: "Cross",
        value: "cross",
        type: "fas",
    },
    {
        label: "Crosshairs",
        value: "crosshairs",
        type: "fas",
    },
    {
        label: "Crow",
        value: "crow",
        type: "fas",
    },
    {
        label: "Crown",
        value: "crown",
        type: "fas",
    },
    {
        label: "Crutch",
        value: "crutch",
        type: "fas",
    },
    {
        label: "Cruzeiro Sign",
        value: "cruzeiro-sign",
        type: "fas",
    },
    {
        label: "Cube",
        value: "cube",
        type: "fas",
    },
    {
        label: "Cubes",
        value: "cubes",
        type: "fas",
    },
    {
        label: "D",
        value: "d",
        type: "fas",
    },
    {
        label: "Database",
        value: "database",
        type: "fas",
    },
    {
        label: "Delete Left",
        value: "delete-left",
        type: "fas",
    },
    {
        label: "Democrat",
        value: "democrat",
        type: "fas",
    },
    {
        label: "Desktop",
        value: "desktop",
        type: "fas",
    },
    {
        label: "Dharmachakra",
        value: "dharmachakra",
        type: "fas",
    },
    {
        label: "Diagram Project",
        value: "diagram-project",
        type: "fas",
    },
    {
        label: "Diamond",
        value: "diamond",
        type: "fas",
    },
    {
        label: "Diamond Turn Right",
        value: "diamond-turn-right",
        type: "fas",
    },
    {
        label: "Dice",
        value: "dice",
        type: "fas",
    },
    {
        label: "Dice D20",
        value: "dice-d20",
        type: "fas",
    },
    {
        label: "Dice D6",
        value: "dice-d6",
        type: "fas",
    },
    {
        label: "Dice Five",
        value: "dice-five",
        type: "fas",
    },
    {
        label: "Dice Four",
        value: "dice-four",
        type: "fas",
    },
    {
        label: "Dice One",
        value: "dice-one",
        type: "fas",
    },
    {
        label: "Dice Six",
        value: "dice-six",
        type: "fas",
    },
    {
        label: "Dice Three",
        value: "dice-three",
        type: "fas",
    },
    {
        label: "Dice Two",
        value: "dice-two",
        type: "fas",
    },
    {
        label: "Disease",
        value: "disease",
        type: "fas",
    },
    {
        label: "Divide",
        value: "divide",
        type: "fas",
    },
    {
        label: "Dna",
        value: "dna",
        type: "fas",
    },
    {
        label: "Dog",
        value: "dog",
        type: "fas",
    },
    {
        label: "Dollar Sign",
        value: "dollar-sign",
        type: "fas",
    },
    {
        label: "Dolly",
        value: "dolly",
        type: "fas",
    },
    {
        label: "Dong Sign",
        value: "dong-sign",
        type: "fas",
    },
    {
        label: "Door Closed",
        value: "door-closed",
        type: "fas",
    },
    {
        label: "Door Open",
        value: "door-open",
        type: "fas",
    },
    {
        label: "Dove",
        value: "dove",
        type: "fas",
    },
    {
        label: "Down Left And Up Right To Center",
        value: "down-left-and-up-right-to-center",
        type: "fas",
    },
    {
        label: "Download",
        value: "download",
        type: "fas",
    },
    {
        label: "Down Long",
        value: "down-long",
        type: "fas",
    },
    {
        label: "Dragon",
        value: "dragon",
        type: "fas",
    },
    {
        label: "Draw Polygon",
        value: "draw-polygon",
        type: "fas",
    },
    {
        label: "Droplet",
        value: "droplet",
        type: "fas",
    },
    {
        label: "Droplet Slash",
        value: "droplet-slash",
        type: "fas",
    },
    {
        label: "Drum",
        value: "drum",
        type: "fas",
    },
    {
        label: "Drum Steelpan",
        value: "drum-steelpan",
        type: "fas",
    },
    {
        label: "Drumstick Bite",
        value: "drumstick-bite",
        type: "fas",
    },
    {
        label: "Dumbbell",
        value: "dumbbell",
        type: "fas",
    },
    {
        label: "Dumpster",
        value: "dumpster",
        type: "fas",
    },
    {
        label: "Dumpster Fire",
        value: "dumpster-fire",
        type: "fas",
    },
    {
        label: "Dungeon",
        value: "dungeon",
        type: "fas",
    },
    {
        label: "E",
        value: "e",
        type: "fas",
    },
    {
        label: "Ear Deaf",
        value: "ear-deaf",
        type: "fas",
    },
    {
        label: "Ear Listen",
        value: "ear-listen",
        type: "fas",
    },
    {
        label: "Earth Africa",
        value: "earth-africa",
        type: "fas",
    },
    {
        label: "Earth Americas",
        value: "earth-americas",
        type: "fas",
    },
    {
        label: "Earth Asia",
        value: "earth-asia",
        type: "fas",
    },
    {
        label: "Earth Europe",
        value: "earth-europe",
        type: "fas",
    },
    {
        label: "Earth Oceania",
        value: "earth-oceania",
        type: "fas",
    },
    {
        label: "Egg",
        value: "egg",
        type: "fas",
    },
    {
        label: "Eject",
        value: "eject",
        type: "fas",
    },
    {
        label: "Elevator",
        value: "elevator",
        type: "fas",
    },
    {
        label: "Ellipsis",
        value: "ellipsis",
        type: "fas",
    },
    {
        label: "Ellipsis Vertical",
        value: "ellipsis-vertical",
        type: "fas",
    },
    {
        label: "Envelope Open Text",
        value: "envelope-open-text",
        type: "fas",
    },
    {
        label: "Envelopes Bulk",
        value: "envelopes-bulk",
        type: "fas",
    },
    {
        label: "Equals",
        value: "equals",
        type: "fas",
    },
    {
        label: "Eraser",
        value: "eraser",
        type: "fas",
    },
    {
        label: "Ethernet",
        value: "ethernet",
        type: "fas",
    },
    {
        label: "Euro Sign",
        value: "euro-sign",
        type: "fas",
    },
    {
        label: "Exclamation",
        value: "exclamation",
        type: "fas",
    },
    {
        label: "Expand",
        value: "expand",
        type: "fas",
    },
    {
        label: "Eye Dropper",
        value: "eye-dropper",
        type: "fas",
    },
    {
        label: "Eye Low Vision",
        value: "eye-low-vision",
        type: "fas",
    },
    {
        label: "F",
        value: "f",
        type: "fas",
    },
    {
        label: "Fan",
        value: "fan",
        type: "fas",
    },
    {
        label: "Faucet",
        value: "faucet",
        type: "fas",
    },
    {
        label: "Fax",
        value: "fax",
        type: "fas",
    },
    {
        label: "Feather",
        value: "feather",
        type: "fas",
    },
    {
        label: "Feather Pointed",
        value: "feather-pointed",
        type: "fas",
    },
    {
        label: "File Arrow Down",
        value: "file-arrow-down",
        type: "fas",
    },
    {
        label: "File Arrow Up",
        value: "file-arrow-up",
        type: "fas",
    },
    {
        label: "File Contract",
        value: "file-contract",
        type: "fas",
    },
    {
        label: "File Csv",
        value: "file-csv",
        type: "fas",
    },
    {
        label: "File Export",
        value: "file-export",
        type: "fas",
    },
    {
        label: "File Import",
        value: "file-import",
        type: "fas",
    },
    {
        label: "File Invoice",
        value: "file-invoice",
        type: "fas",
    },
    {
        label: "File Invoice Dollar",
        value: "file-invoice-dollar",
        type: "fas",
    },
    {
        label: "File Medical",
        value: "file-medical",
        type: "fas",
    },
    {
        label: "File Prescription",
        value: "file-prescription",
        type: "fas",
    },
    {
        label: "File Signature",
        value: "file-signature",
        type: "fas",
    },
    {
        label: "File Waveform",
        value: "file-waveform",
        type: "fas",
    },
    {
        label: "Fill",
        value: "fill",
        type: "fas",
    },
    {
        label: "Fill Drip",
        value: "fill-drip",
        type: "fas",
    },
    {
        label: "Film",
        value: "film",
        type: "fas",
    },
    {
        label: "Filter",
        value: "filter",
        type: "fas",
    },
    {
        label: "Filter Circle Dollar",
        value: "filter-circle-dollar",
        type: "fas",
    },
    {
        label: "Filter Circle Xmark",
        value: "filter-circle-xmark",
        type: "fas",
    },
    {
        label: "Fingerprint",
        value: "fingerprint",
        type: "fas",
    },
    {
        label: "Fire",
        value: "fire",
        type: "fas",
    },
    {
        label: "Fire Extinguisher",
        value: "fire-extinguisher",
        type: "fas",
    },
    {
        label: "Fire Flame Curved",
        value: "fire-flame-curved",
        type: "fas",
    },
    {
        label: "Fire Flame Simple",
        value: "fire-flame-simple",
        type: "fas",
    },
    {
        label: "Fish",
        value: "fish",
        type: "fas",
    },
    {
        label: "Flag Checkered",
        value: "flag-checkered",
        type: "fas",
    },
    {
        label: "Flag Usa",
        value: "flag-usa",
        type: "fas",
    },
    {
        label: "Flask",
        value: "flask",
        type: "fas",
    },
    {
        label: "Florin Sign",
        value: "florin-sign",
        type: "fas",
    },
    {
        label: "Folder Minus",
        value: "folder-minus",
        type: "fas",
    },
    {
        label: "Folder Plus",
        value: "folder-plus",
        type: "fas",
    },
    {
        label: "Folder Tree",
        value: "folder-tree",
        type: "fas",
    },
    {
        label: "Font",
        value: "font",
        type: "fas",
    },
    {
        label: "Football",
        value: "football",
        type: "fas",
    },
    {
        label: "Forward",
        value: "forward",
        type: "fas",
    },
    {
        label: "Forward Fast",
        value: "forward-fast",
        type: "fas",
    },
    {
        label: "Forward Step",
        value: "forward-step",
        type: "fas",
    },
    {
        label: "Franc Sign",
        value: "franc-sign",
        type: "fas",
    },
    {
        label: "Frog",
        value: "frog",
        type: "fas",
    },
    {
        label: "G",
        value: "g",
        type: "fas",
    },
    {
        label: "Gamepad",
        value: "gamepad",
        type: "fas",
    },
    {
        label: "Gas Pump",
        value: "gas-pump",
        type: "fas",
    },
    {
        label: "Gauge",
        value: "gauge",
        type: "fas",
    },
    {
        label: "Gauge High",
        value: "gauge-high",
        type: "fas",
    },
    {
        label: "Gauge Simple",
        value: "gauge-simple",
        type: "fas",
    },
    {
        label: "Gauge Simple High",
        value: "gauge-simple-high",
        type: "fas",
    },
    {
        label: "Gavel",
        value: "gavel",
        type: "fas",
    },
    {
        label: "Gear",
        value: "gear",
        type: "fas",
    },
    {
        label: "Gears",
        value: "gears",
        type: "fas",
    },
    {
        label: "Genderless",
        value: "genderless",
        type: "fas",
    },
    {
        label: "Ghost",
        value: "ghost",
        type: "fas",
    },
    {
        label: "Gift",
        value: "gift",
        type: "fas",
    },
    {
        label: "Gifts",
        value: "gifts",
        type: "fas",
    },
    {
        label: "Glasses",
        value: "glasses",
        type: "fas",
    },
    {
        label: "Globe",
        value: "globe",
        type: "fas",
    },
    {
        label: "Golf Ball Tee",
        value: "golf-ball-tee",
        type: "fas",
    },
    {
        label: "Gopuram",
        value: "gopuram",
        type: "fas",
    },
    {
        label: "Graduation Cap",
        value: "graduation-cap",
        type: "fas",
    },
    {
        label: "Greater Than",
        value: "greater-than",
        type: "fas",
    },
    {
        label: "Greater Than Equal",
        value: "greater-than-equal",
        type: "fas",
    },
    {
        label: "Grip",
        value: "grip",
        type: "fas",
    },
    {
        label: "Grip Lines",
        value: "grip-lines",
        type: "fas",
    },
    {
        label: "Grip Lines Vertical",
        value: "grip-lines-vertical",
        type: "fas",
    },
    {
        label: "Grip Vertical",
        value: "grip-vertical",
        type: "fas",
    },
    {
        label: "Guarani Sign",
        value: "guarani-sign",
        type: "fas",
    },
    {
        label: "Guitar",
        value: "guitar",
        type: "fas",
    },
    {
        label: "Gun",
        value: "gun",
        type: "fas",
    },
    {
        label: "H",
        value: "h",
        type: "fas",
    },
    {
        label: "Hammer",
        value: "hammer",
        type: "fas",
    },
    {
        label: "Hamsa",
        value: "hamsa",
        type: "fas",
    },
    {
        label: "Hand Dots",
        value: "hand-dots",
        type: "fas",
    },
    {
        label: "Hand Fist",
        value: "hand-fist",
        type: "fas",
    },
    {
        label: "Hand Holding",
        value: "hand-holding",
        type: "fas",
    },
    {
        label: "Hand Holding Dollar",
        value: "hand-holding-dollar",
        type: "fas",
    },
    {
        label: "Hand Holding Droplet",
        value: "hand-holding-droplet",
        type: "fas",
    },
    {
        label: "Hand Holding Heart",
        value: "hand-holding-heart",
        type: "fas",
    },
    {
        label: "Hand Holding Medical",
        value: "hand-holding-medical",
        type: "fas",
    },
    {
        label: "Hand Middle Finger",
        value: "hand-middle-finger",
        type: "fas",
    },
    {
        label: "Hands",
        value: "hands",
        type: "fas",
    },
    {
        label: "Hands Asl Interpreting",
        value: "hands-asl-interpreting",
        type: "fas",
    },
    {
        label: "Hands Bubbles",
        value: "hands-bubbles",
        type: "fas",
    },
    {
        label: "Hands Clapping",
        value: "hands-clapping",
        type: "fas",
    },
    {
        label: "Handshake Angle",
        value: "handshake-angle",
        type: "fas",
    },
    {
        label: "Handshake Simple Slash",
        value: "handshake-simple-slash",
        type: "fas",
    },
    {
        label: "Handshake Slash",
        value: "handshake-slash",
        type: "fas",
    },
    {
        label: "Hands Holding",
        value: "hands-holding",
        type: "fas",
    },
    {
        label: "Hand Sparkles",
        value: "hand-sparkles",
        type: "fas",
    },
    {
        label: "Hands Praying",
        value: "hands-praying",
        type: "fas",
    },
    {
        label: "Hanukiah",
        value: "hanukiah",
        type: "fas",
    },
    {
        label: "Hashtag",
        value: "hashtag",
        type: "fas",
    },
    {
        label: "Hat Cowboy",
        value: "hat-cowboy",
        type: "fas",
    },
    {
        label: "Hat Cowboy Side",
        value: "hat-cowboy-side",
        type: "fas",
    },
    {
        label: "Hat Wizard",
        value: "hat-wizard",
        type: "fas",
    },
    {
        label: "Heading",
        value: "heading",
        type: "fas",
    },
    {
        label: "Headphones",
        value: "headphones",
        type: "fas",
    },
    {
        label: "Headphones Simple",
        value: "headphones-simple",
        type: "fas",
    },
    {
        label: "Headset",
        value: "headset",
        type: "fas",
    },
    {
        label: "Head Side Cough",
        value: "head-side-cough",
        type: "fas",
    },
    {
        label: "Head Side Cough Slash",
        value: "head-side-cough-slash",
        type: "fas",
    },
    {
        label: "Head Side Mask",
        value: "head-side-mask",
        type: "fas",
    },
    {
        label: "Head Side Virus",
        value: "head-side-virus",
        type: "fas",
    },
    {
        label: "Heart Crack",
        value: "heart-crack",
        type: "fas",
    },
    {
        label: "Heart Pulse",
        value: "heart-pulse",
        type: "fas",
    },
    {
        label: "Helicopter",
        value: "helicopter",
        type: "fas",
    },
    {
        label: "Helmet Safety",
        value: "helmet-safety",
        type: "fas",
    },
    {
        label: "Highlighter",
        value: "highlighter",
        type: "fas",
    },
    {
        label: "Hippo",
        value: "hippo",
        type: "fas",
    },
    {
        label: "Hockey Puck",
        value: "hockey-puck",
        type: "fas",
    },
    {
        label: "Holly Berry",
        value: "holly-berry",
        type: "fas",
    },
    {
        label: "Horse",
        value: "horse",
        type: "fas",
    },
    {
        label: "Horse Head",
        value: "horse-head",
        type: "fas",
    },
    {
        label: "Hospital User",
        value: "hospital-user",
        type: "fas",
    },
    {
        label: "Hotdog",
        value: "hotdog",
        type: "fas",
    },
    {
        label: "Hotel",
        value: "hotel",
        type: "fas",
    },
    {
        label: "Hot Tub Person",
        value: "hot-tub-person",
        type: "fas",
    },
    {
        label: "Hourglass End",
        value: "hourglass-end",
        type: "fas",
    },
    {
        label: "Hourglass Start",
        value: "hourglass-start",
        type: "fas",
    },
    {
        label: "House",
        value: "house",
        type: "fas",
    },
    {
        label: "House Chimney",
        value: "house-chimney",
        type: "fas",
    },
    {
        label: "House Chimney Crack",
        value: "house-chimney-crack",
        type: "fas",
    },
    {
        label: "House Chimney Medical",
        value: "house-chimney-medical",
        type: "fas",
    },
    {
        label: "House Chimney User",
        value: "house-chimney-user",
        type: "fas",
    },
    {
        label: "House Crack",
        value: "house-crack",
        type: "fas",
    },
    {
        label: "House Laptop",
        value: "house-laptop",
        type: "fas",
    },
    {
        label: "House Medical",
        value: "house-medical",
        type: "fas",
    },
    {
        label: "House User",
        value: "house-user",
        type: "fas",
    },
    {
        label: "Hryvnia Sign",
        value: "hryvnia-sign",
        type: "fas",
    },
    {
        label: "I",
        value: "i",
        type: "fas",
    },
    {
        label: "Ice Cream",
        value: "ice-cream",
        type: "fas",
    },
    {
        label: "Icicles",
        value: "icicles",
        type: "fas",
    },
    {
        label: "Icons",
        value: "icons",
        type: "fas",
    },
    {
        label: "I Cursor",
        value: "i-cursor",
        type: "fas",
    },
    {
        label: "Id Card Clip",
        value: "id-card-clip",
        type: "fas",
    },
    {
        label: "Igloo",
        value: "igloo",
        type: "fas",
    },
    {
        label: "Image Portrait",
        value: "image-portrait",
        type: "fas",
    },
    {
        label: "Inbox",
        value: "inbox",
        type: "fas",
    },
    {
        label: "Indent",
        value: "indent",
        type: "fas",
    },
    {
        label: "Indian Rupee Sign",
        value: "indian-rupee-sign",
        type: "fas",
    },
    {
        label: "Industry",
        value: "industry",
        type: "fas",
    },
    {
        label: "Infinity",
        value: "infinity",
        type: "fas",
    },
    {
        label: "Info",
        value: "info",
        type: "fas",
    },
    {
        label: "Italic",
        value: "italic",
        type: "fas",
    },
    {
        label: "J",
        value: "j",
        type: "fas",
    },
    {
        label: "Jedi",
        value: "jedi",
        type: "fas",
    },
    {
        label: "Jet Fighter",
        value: "jet-fighter",
        type: "fas",
    },
    {
        label: "Joint",
        value: "joint",
        type: "fas",
    },
    {
        label: "K",
        value: "k",
        type: "fas",
    },
    {
        label: "Kaaba",
        value: "kaaba",
        type: "fas",
    },
    {
        label: "Key",
        value: "key",
        type: "fas",
    },
    {
        label: "Khanda",
        value: "khanda",
        type: "fas",
    },
    {
        label: "Kip Sign",
        value: "kip-sign",
        type: "fas",
    },
    {
        label: "Kit Medical",
        value: "kit-medical",
        type: "fas",
    },
    {
        label: "Kiwi Bird",
        value: "kiwi-bird",
        type: "fas",
    },
    {
        label: "L",
        value: "l",
        type: "fas",
    },
    {
        label: "Landmark",
        value: "landmark",
        type: "fas",
    },
    {
        label: "Language",
        value: "language",
        type: "fas",
    },
    {
        label: "Laptop",
        value: "laptop",
        type: "fas",
    },
    {
        label: "Laptop Code",
        value: "laptop-code",
        type: "fas",
    },
    {
        label: "Laptop Medical",
        value: "laptop-medical",
        type: "fas",
    },
    {
        label: "Lari Sign",
        value: "lari-sign",
        type: "fas",
    },
    {
        label: "Layer Group",
        value: "layer-group",
        type: "fas",
    },
    {
        label: "Leaf",
        value: "leaf",
        type: "fas",
    },
    {
        label: "Left Long",
        value: "left-long",
        type: "fas",
    },
    {
        label: "Left Right",
        value: "left-right",
        type: "fas",
    },
    {
        label: "Less Than",
        value: "less-than",
        type: "fas",
    },
    {
        label: "Less Than Equal",
        value: "less-than-equal",
        type: "fas",
    },
    {
        label: "Link",
        value: "link",
        type: "fas",
    },
    {
        label: "Link Slash",
        value: "link-slash",
        type: "fas",
    },
    {
        label: "Lira Sign",
        value: "lira-sign",
        type: "fas",
    },
    {
        label: "List",
        value: "list",
        type: "fas",
    },
    {
        label: "List Check",
        value: "list-check",
        type: "fas",
    },
    {
        label: "List Ol",
        value: "list-ol",
        type: "fas",
    },
    {
        label: "List Ul",
        value: "list-ul",
        type: "fas",
    },
    {
        label: "Litecoin Sign",
        value: "litecoin-sign",
        type: "fas",
    },
    {
        label: "Location Arrow",
        value: "location-arrow",
        type: "fas",
    },
    {
        label: "Location Crosshairs",
        value: "location-crosshairs",
        type: "fas",
    },
    {
        label: "Location Dot",
        value: "location-dot",
        type: "fas",
    },
    {
        label: "Location Pin",
        value: "location-pin",
        type: "fas",
    },
    {
        label: "Lock",
        value: "lock",
        type: "fas",
    },
    {
        label: "Lock Open",
        value: "lock-open",
        type: "fas",
    },
    {
        label: "Lungs",
        value: "lungs",
        type: "fas",
    },
    {
        label: "Lungs Virus",
        value: "lungs-virus",
        type: "fas",
    },
    {
        label: "M",
        value: "m",
        type: "fas",
    },
    {
        label: "Magnet",
        value: "magnet",
        type: "fas",
    },
    {
        label: "Magnifying Glass",
        value: "magnifying-glass",
        type: "fas",
    },
    {
        label: "Magnifying Glass Dollar",
        value: "magnifying-glass-dollar",
        type: "fas",
    },
    {
        label: "Magnifying Glass Location",
        value: "magnifying-glass-location",
        type: "fas",
    },
    {
        label: "Magnifying Glass Minus",
        value: "magnifying-glass-minus",
        type: "fas",
    },
    {
        label: "Magnifying Glass Plus",
        value: "magnifying-glass-plus",
        type: "fas",
    },
    {
        label: "Manat Sign",
        value: "manat-sign",
        type: "fas",
    },
    {
        label: "Map Location",
        value: "map-location",
        type: "fas",
    },
    {
        label: "Map Location Dot",
        value: "map-location-dot",
        type: "fas",
    },
    {
        label: "Map Pin",
        value: "map-pin",
        type: "fas",
    },
    {
        label: "Marker",
        value: "marker",
        type: "fas",
    },
    {
        label: "Mars",
        value: "mars",
        type: "fas",
    },
    {
        label: "Mars And Venus",
        value: "mars-and-venus",
        type: "fas",
    },
    {
        label: "Mars Double",
        value: "mars-double",
        type: "fas",
    },
    {
        label: "Mars Stroke",
        value: "mars-stroke",
        type: "fas",
    },
    {
        label: "Mars Stroke Right",
        value: "mars-stroke-right",
        type: "fas",
    },
    {
        label: "Mars Stroke Up",
        value: "mars-stroke-up",
        type: "fas",
    },
    {
        label: "Martini Glass",
        value: "martini-glass",
        type: "fas",
    },
    {
        label: "Martini Glass Citrus",
        value: "martini-glass-citrus",
        type: "fas",
    },
    {
        label: "Martini Glass Empty",
        value: "martini-glass-empty",
        type: "fas",
    },
    {
        label: "Mask",
        value: "mask",
        type: "fas",
    },
    {
        label: "Mask Face",
        value: "mask-face",
        type: "fas",
    },
    {
        label: "Masks Theater",
        value: "masks-theater",
        type: "fas",
    },
    {
        label: "Maximize",
        value: "maximize",
        type: "fas",
    },
    {
        label: "Medal",
        value: "medal",
        type: "fas",
    },
    {
        label: "Memory",
        value: "memory",
        type: "fas",
    },
    {
        label: "Menorah",
        value: "menorah",
        type: "fas",
    },
    {
        label: "Mercury",
        value: "mercury",
        type: "fas",
    },
    {
        label: "Meteor",
        value: "meteor",
        type: "fas",
    },
    {
        label: "Microchip",
        value: "microchip",
        type: "fas",
    },
    {
        label: "Microphone",
        value: "microphone",
        type: "fas",
    },
    {
        label: "Microphone Lines",
        value: "microphone-lines",
        type: "fas",
    },
    {
        label: "Microphone Lines Slash",
        value: "microphone-lines-slash",
        type: "fas",
    },
    {
        label: "Microphone Slash",
        value: "microphone-slash",
        type: "fas",
    },
    {
        label: "Microscope",
        value: "microscope",
        type: "fas",
    },
    {
        label: "Mill Sign",
        value: "mill-sign",
        type: "fas",
    },
    {
        label: "Minimize",
        value: "minimize",
        type: "fas",
    },
    {
        label: "Minus",
        value: "minus",
        type: "fas",
    },
    {
        label: "Mitten",
        value: "mitten",
        type: "fas",
    },
    {
        label: "Mobile Button",
        value: "mobile-button",
        type: "fas",
    },
    {
        label: "Mobile Screen Button",
        value: "mobile-screen-button",
        type: "fas",
    },
    {
        label: "Money Bill",
        value: "money-bill",
        type: "fas",
    },
    {
        label: "Money Bill Wave",
        value: "money-bill-wave",
        type: "fas",
    },
    {
        label: "Money Check",
        value: "money-check",
        type: "fas",
    },
    {
        label: "Money Check Dollar",
        value: "money-check-dollar",
        type: "fas",
    },
    {
        label: "Monument",
        value: "monument",
        type: "fas",
    },
    {
        label: "Mortar Pestle",
        value: "mortar-pestle",
        type: "fas",
    },
    {
        label: "Mosque",
        value: "mosque",
        type: "fas",
    },
    {
        label: "Motorcycle",
        value: "motorcycle",
        type: "fas",
    },
    {
        label: "Mountain",
        value: "mountain",
        type: "fas",
    },
    {
        label: "Mug Hot",
        value: "mug-hot",
        type: "fas",
    },
    {
        label: "Mug Saucer",
        value: "mug-saucer",
        type: "fas",
    },
    {
        label: "Music",
        value: "music",
        type: "fas",
    },
    {
        label: "N",
        value: "n",
        type: "fas",
    },
    {
        label: "Naira Sign",
        value: "naira-sign",
        type: "fas",
    },
    {
        label: "Network Wired",
        value: "network-wired",
        type: "fas",
    },
    {
        label: "Neuter",
        value: "neuter",
        type: "fas",
    },
    {
        label: "Not Equal",
        value: "not-equal",
        type: "fas",
    },
    {
        label: "Notes Medical",
        value: "notes-medical",
        type: "fas",
    },
    {
        label: "O",
        value: "o",
        type: "fas",
    },
    {
        label: "Oil Can",
        value: "oil-can",
        type: "fas",
    },
    {
        label: "Om",
        value: "om",
        type: "fas",
    },
    {
        label: "Otter",
        value: "otter",
        type: "fas",
    },
    {
        label: "Outdent",
        value: "outdent",
        type: "fas",
    },
    {
        label: "P",
        value: "p",
        type: "fas",
    },
    {
        label: "Pager",
        value: "pager",
        type: "fas",
    },
    {
        label: "Paint Roller",
        value: "paint-roller",
        type: "fas",
    },
    {
        label: "Palette",
        value: "palette",
        type: "fas",
    },
    {
        label: "Pallet",
        value: "pallet",
        type: "fas",
    },
    {
        label: "Panorama",
        value: "panorama",
        type: "fas",
    },
    {
        label: "Paperclip",
        value: "paperclip",
        type: "fas",
    },
    {
        label: "Parachute Box",
        value: "parachute-box",
        type: "fas",
    },
    {
        label: "Paragraph",
        value: "paragraph",
        type: "fas",
    },
    {
        label: "Passport",
        value: "passport",
        type: "fas",
    },
    {
        label: "Pause",
        value: "pause",
        type: "fas",
    },
    {
        label: "Paw",
        value: "paw",
        type: "fas",
    },
    {
        label: "Peace",
        value: "peace",
        type: "fas",
    },
    {
        label: "Pen",
        value: "pen",
        type: "fas",
    },
    {
        label: "Pencil",
        value: "pencil",
        type: "fas",
    },
    {
        label: "Pen Clip",
        value: "pen-clip",
        type: "fas",
    },
    {
        label: "Pen Fancy",
        value: "pen-fancy",
        type: "fas",
    },
    {
        label: "Pen Nib",
        value: "pen-nib",
        type: "fas",
    },
    {
        label: "Pen Ruler",
        value: "pen-ruler",
        type: "fas",
    },
    {
        label: "People Arrows",
        value: "people-arrows",
        type: "fas",
    },
    {
        label: "People Carry Box",
        value: "people-carry-box",
        type: "fas",
    },
    {
        label: "Pepper Hot",
        value: "pepper-hot",
        type: "fas",
    },
    {
        label: "Percent",
        value: "percent",
        type: "fas",
    },
    {
        label: "Person",
        value: "person",
        type: "fas",
    },
    {
        label: "Person Biking",
        value: "person-biking",
        type: "fas",
    },
    {
        label: "Person Booth",
        value: "person-booth",
        type: "fas",
    },
    {
        label: "Person Dots From Line",
        value: "person-dots-from-line",
        type: "fas",
    },
    {
        label: "Person Dress",
        value: "person-dress",
        type: "fas",
    },
    {
        label: "Person Hiking",
        value: "person-hiking",
        type: "fas",
    },
    {
        label: "Person Praying",
        value: "person-praying",
        type: "fas",
    },
    {
        label: "Person Running",
        value: "person-running",
        type: "fas",
    },
    {
        label: "Person Skating",
        value: "person-skating",
        type: "fas",
    },
    {
        label: "Person Skiing",
        value: "person-skiing",
        type: "fas",
    },
    {
        label: "Person Skiing Nordic",
        value: "person-skiing-nordic",
        type: "fas",
    },
    {
        label: "Person Snowboarding",
        value: "person-snowboarding",
        type: "fas",
    },
    {
        label: "Person Swimming",
        value: "person-swimming",
        type: "fas",
    },
    {
        label: "Person Walking",
        value: "person-walking",
        type: "fas",
    },
    {
        label: "Person Walking With Cane",
        value: "person-walking-with-cane",
        type: "fas",
    },
    {
        label: "Peseta Sign",
        value: "peseta-sign",
        type: "fas",
    },
    {
        label: "Peso Sign",
        value: "peso-sign",
        type: "fas",
    },
    {
        label: "Phone",
        value: "phone",
        type: "fas",
    },
    {
        label: "Phone Flip",
        value: "phone-flip",
        type: "fas",
    },
    {
        label: "Phone Slash",
        value: "phone-slash",
        type: "fas",
    },
    {
        label: "Phone Volume",
        value: "phone-volume",
        type: "fas",
    },
    {
        label: "Photo Film",
        value: "photo-film",
        type: "fas",
    },
    {
        label: "Piggy Bank",
        value: "piggy-bank",
        type: "fas",
    },
    {
        label: "Pills",
        value: "pills",
        type: "fas",
    },
    {
        label: "Pizza Slice",
        value: "pizza-slice",
        type: "fas",
    },
    {
        label: "Place Of Worship",
        value: "place-of-worship",
        type: "fas",
    },
    {
        label: "Plane",
        value: "plane",
        type: "fas",
    },
    {
        label: "Plane Arrival",
        value: "plane-arrival",
        type: "fas",
    },
    {
        label: "Plane Departure",
        value: "plane-departure",
        type: "fas",
    },
    {
        label: "Plane Slash",
        value: "plane-slash",
        type: "fas",
    },
    {
        label: "Play",
        value: "play",
        type: "fas",
    },
    {
        label: "Plug",
        value: "plug",
        type: "fas",
    },
    {
        label: "Plus",
        value: "plus",
        type: "fas",
    },
    {
        label: "Plus Minus",
        value: "plus-minus",
        type: "fas",
    },
    {
        label: "Podcast",
        value: "podcast",
        type: "fas",
    },
    {
        label: "Poo",
        value: "poo",
        type: "fas",
    },
    {
        label: "Poop",
        value: "poop",
        type: "fas",
    },
    {
        label: "Poo Storm",
        value: "poo-storm",
        type: "fas",
    },
    {
        label: "Power Off",
        value: "power-off",
        type: "fas",
    },
    {
        label: "Prescription",
        value: "prescription",
        type: "fas",
    },
    {
        label: "Prescription Bottle",
        value: "prescription-bottle",
        type: "fas",
    },
    {
        label: "Prescription Bottle Medical",
        value: "prescription-bottle-medical",
        type: "fas",
    },
    {
        label: "Print",
        value: "print",
        type: "fas",
    },
    {
        label: "Pump Medical",
        value: "pump-medical",
        type: "fas",
    },
    {
        label: "Pump Soap",
        value: "pump-soap",
        type: "fas",
    },
    {
        label: "Puzzle Piece",
        value: "puzzle-piece",
        type: "fas",
    },
    {
        label: "Q",
        value: "q",
        type: "fas",
    },
    {
        label: "Qrcode",
        value: "qrcode",
        type: "fas",
    },
    {
        label: "Question",
        value: "question",
        type: "fas",
    },
    {
        label: "Quote Left",
        value: "quote-left",
        type: "fas",
    },
    {
        label: "Quote Right",
        value: "quote-right",
        type: "fas",
    },
    {
        label: "R",
        value: "r",
        type: "fas",
    },
    {
        label: "Radiation",
        value: "radiation",
        type: "fas",
    },
    {
        label: "Rainbow",
        value: "rainbow",
        type: "fas",
    },
    {
        label: "Receipt",
        value: "receipt",
        type: "fas",
    },
    {
        label: "Record Vinyl",
        value: "record-vinyl",
        type: "fas",
    },
    {
        label: "Rectangle Ad",
        value: "rectangle-ad",
        type: "fas",
    },
    {
        label: "Recycle",
        value: "recycle",
        type: "fas",
    },
    {
        label: "Repeat",
        value: "repeat",
        type: "fas",
    },
    {
        label: "Reply",
        value: "reply",
        type: "fas",
    },
    {
        label: "Reply All",
        value: "reply-all",
        type: "fas",
    },
    {
        label: "Republican",
        value: "republican",
        type: "fas",
    },
    {
        label: "Restroom",
        value: "restroom",
        type: "fas",
    },
    {
        label: "Retweet",
        value: "retweet",
        type: "fas",
    },
    {
        label: "Ribbon",
        value: "ribbon",
        type: "fas",
    },
    {
        label: "Right From Bracket",
        value: "right-from-bracket",
        type: "fas",
    },
    {
        label: "Right Left",
        value: "right-left",
        type: "fas",
    },
    {
        label: "Right Long",
        value: "right-long",
        type: "fas",
    },
    {
        label: "Right To Bracket",
        value: "right-to-bracket",
        type: "fas",
    },
    {
        label: "Ring",
        value: "ring",
        type: "fas",
    },
    {
        label: "Road",
        value: "road",
        type: "fas",
    },
    {
        label: "Robot",
        value: "robot",
        type: "fas",
    },
    {
        label: "Rocket",
        value: "rocket",
        type: "fas",
    },
    {
        label: "Rotate",
        value: "rotate",
        type: "fas",
    },
    {
        label: "Rotate Left",
        value: "rotate-left",
        type: "fas",
    },
    {
        label: "Rotate Right",
        value: "rotate-right",
        type: "fas",
    },
    {
        label: "Route",
        value: "route",
        type: "fas",
    },
    {
        label: "Rss",
        value: "rss",
        type: "fas",
    },
    {
        label: "Ruble Sign",
        value: "ruble-sign",
        type: "fas",
    },
    {
        label: "Ruler",
        value: "ruler",
        type: "fas",
    },
    {
        label: "Ruler Combined",
        value: "ruler-combined",
        type: "fas",
    },
    {
        label: "Ruler Horizontal",
        value: "ruler-horizontal",
        type: "fas",
    },
    {
        label: "Ruler Vertical",
        value: "ruler-vertical",
        type: "fas",
    },
    {
        label: "Rupee Sign",
        value: "rupee-sign",
        type: "fas",
    },
    {
        label: "Rupiah Sign",
        value: "rupiah-sign",
        type: "fas",
    },
    {
        label: "S",
        value: "s",
        type: "fas",
    },
    {
        label: "Sailboat",
        value: "sailboat",
        type: "fas",
    },
    {
        label: "Satellite",
        value: "satellite",
        type: "fas",
    },
    {
        label: "Satellite Dish",
        value: "satellite-dish",
        type: "fas",
    },
    {
        label: "Scale Balanced",
        value: "scale-balanced",
        type: "fas",
    },
    {
        label: "Scale Unbalanced",
        value: "scale-unbalanced",
        type: "fas",
    },
    {
        label: "Scale Unbalanced Flip",
        value: "scale-unbalanced-flip",
        type: "fas",
    },
    {
        label: "School",
        value: "school",
        type: "fas",
    },
    {
        label: "Scissors",
        value: "scissors",
        type: "fas",
    },
    {
        label: "Screwdriver",
        value: "screwdriver",
        type: "fas",
    },
    {
        label: "Screwdriver Wrench",
        value: "screwdriver-wrench",
        type: "fas",
    },
    {
        label: "Scroll",
        value: "scroll",
        type: "fas",
    },
    {
        label: "Scroll Torah",
        value: "scroll-torah",
        type: "fas",
    },
    {
        label: "Sd Card",
        value: "sd-card",
        type: "fas",
    },
    {
        label: "Section",
        value: "section",
        type: "fas",
    },
    {
        label: "Seedling",
        value: "seedling",
        type: "fas",
    },
    {
        label: "Server",
        value: "server",
        type: "fas",
    },
    {
        label: "Shapes",
        value: "shapes",
        type: "fas",
    },
    {
        label: "Share",
        value: "share",
        type: "fas",
    },
    {
        label: "Share Nodes",
        value: "share-nodes",
        type: "fas",
    },
    {
        label: "Shekel Sign",
        value: "shekel-sign",
        type: "fas",
    },
    {
        label: "Shield",
        value: "shield",
        type: "fas",
    },
    {
        label: "Shield Virus",
        value: "shield-virus",
        type: "fas",
    },
    {
        label: "Ship",
        value: "ship",
        type: "fas",
    },
    {
        label: "Shirt",
        value: "shirt",
        type: "fas",
    },
    {
        label: "Shoe Prints",
        value: "shoe-prints",
        type: "fas",
    },
    {
        label: "Shop",
        value: "shop",
        type: "fas",
    },
    {
        label: "Shop Slash",
        value: "shop-slash",
        type: "fas",
    },
    {
        label: "Shower",
        value: "shower",
        type: "fas",
    },
    {
        label: "Shrimp",
        value: "shrimp",
        type: "fas",
    },
    {
        label: "Shuffle",
        value: "shuffle",
        type: "fas",
    },
    {
        label: "Shuttle Space",
        value: "shuttle-space",
        type: "fas",
    },
    {
        label: "Signal",
        value: "signal",
        type: "fas",
    },
    {
        label: "Signature",
        value: "signature",
        type: "fas",
    },
    {
        label: "Sign Hanging",
        value: "sign-hanging",
        type: "fas",
    },
    {
        label: "Signs Post",
        value: "signs-post",
        type: "fas",
    },
    {
        label: "Sim Card",
        value: "sim-card",
        type: "fas",
    },
    {
        label: "Sink",
        value: "sink",
        type: "fas",
    },
    {
        label: "Sitemap",
        value: "sitemap",
        type: "fas",
    },
    {
        label: "Skull",
        value: "skull",
        type: "fas",
    },
    {
        label: "Skull Crossbones",
        value: "skull-crossbones",
        type: "fas",
    },
    {
        label: "Slash",
        value: "slash",
        type: "fas",
    },
    {
        label: "Sleigh",
        value: "sleigh",
        type: "fas",
    },
    {
        label: "Sliders",
        value: "sliders",
        type: "fas",
    },
    {
        label: "Smog",
        value: "smog",
        type: "fas",
    },
    {
        label: "Smoking",
        value: "smoking",
        type: "fas",
    },
    {
        label: "Snowman",
        value: "snowman",
        type: "fas",
    },
    {
        label: "Snowplow",
        value: "snowplow",
        type: "fas",
    },
    {
        label: "Soap",
        value: "soap",
        type: "fas",
    },
    {
        label: "Socks",
        value: "socks",
        type: "fas",
    },
    {
        label: "Solar Panel",
        value: "solar-panel",
        type: "fas",
    },
    {
        label: "Sort",
        value: "sort",
        type: "fas",
    },
    {
        label: "Sort Down",
        value: "sort-down",
        type: "fas",
    },
    {
        label: "Sort Up",
        value: "sort-up",
        type: "fas",
    },
    {
        label: "Spa",
        value: "spa",
        type: "fas",
    },
    {
        label: "Spaghetti Monster Flying",
        value: "spaghetti-monster-flying",
        type: "fas",
    },
    {
        label: "Spell Check",
        value: "spell-check",
        type: "fas",
    },
    {
        label: "Spider",
        value: "spider",
        type: "fas",
    },
    {
        label: "Spinner",
        value: "spinner",
        type: "fas",
    },
    {
        label: "Splotch",
        value: "splotch",
        type: "fas",
    },
    {
        label: "Spoon",
        value: "spoon",
        type: "fas",
    },
    {
        label: "Spray Can",
        value: "spray-can",
        type: "fas",
    },
    {
        label: "Spray Can Sparkles",
        value: "spray-can-sparkles",
        type: "fas",
    },
    {
        label: "Square Arrow Up Right",
        value: "square-arrow-up-right",
        type: "fas",
    },
    {
        label: "Square Envelope",
        value: "square-envelope",
        type: "fas",
    },
    {
        label: "Square H",
        value: "square-h",
        type: "fas",
    },
    {
        label: "Square Parking",
        value: "square-parking",
        type: "fas",
    },
    {
        label: "Square Pen",
        value: "square-pen",
        type: "fas",
    },
    {
        label: "Square Phone",
        value: "square-phone",
        type: "fas",
    },
    {
        label: "Square Phone Flip",
        value: "square-phone-flip",
        type: "fas",
    },
    {
        label: "Square Poll Horizontal",
        value: "square-poll-horizontal",
        type: "fas",
    },
    {
        label: "Square Poll Vertical",
        value: "square-poll-vertical",
        type: "fas",
    },
    {
        label: "Square Root Variable",
        value: "square-root-variable",
        type: "fas",
    },
    {
        label: "Square Rss",
        value: "square-rss",
        type: "fas",
    },
    {
        label: "Square Share Nodes",
        value: "square-share-nodes",
        type: "fas",
    },
    {
        label: "Square Up Right",
        value: "square-up-right",
        type: "fas",
    },
    {
        label: "Square Xmark",
        value: "square-xmark",
        type: "fas",
    },
    {
        label: "Stairs",
        value: "stairs",
        type: "fas",
    },
    {
        label: "Stamp",
        value: "stamp",
        type: "fas",
    },
    {
        label: "Star And Crescent",
        value: "star-and-crescent",
        type: "fas",
    },
    {
        label: "Star Of David",
        value: "star-of-david",
        type: "fas",
    },
    {
        label: "Star Of Life",
        value: "star-of-life",
        type: "fas",
    },
    {
        label: "Sterling Sign",
        value: "sterling-sign",
        type: "fas",
    },
    {
        label: "Stethoscope",
        value: "stethoscope",
        type: "fas",
    },
    {
        label: "Stop",
        value: "stop",
        type: "fas",
    },
    {
        label: "Stopwatch",
        value: "stopwatch",
        type: "fas",
    },
    {
        label: "Store",
        value: "store",
        type: "fas",
    },
    {
        label: "Store Slash",
        value: "store-slash",
        type: "fas",
    },
    {
        label: "Street View",
        value: "street-view",
        type: "fas",
    },
    {
        label: "Strikethrough",
        value: "strikethrough",
        type: "fas",
    },
    {
        label: "Stroopwafel",
        value: "stroopwafel",
        type: "fas",
    },
    {
        label: "Subscript",
        value: "subscript",
        type: "fas",
    },
    {
        label: "Suitcase",
        value: "suitcase",
        type: "fas",
    },
    {
        label: "Suitcase Medical",
        value: "suitcase-medical",
        type: "fas",
    },
    {
        label: "Suitcase Rolling",
        value: "suitcase-rolling",
        type: "fas",
    },
    {
        label: "Superscript",
        value: "superscript",
        type: "fas",
    },
    {
        label: "Swatchbook",
        value: "swatchbook",
        type: "fas",
    },
    {
        label: "Synagogue",
        value: "synagogue",
        type: "fas",
    },
    {
        label: "Syringe",
        value: "syringe",
        type: "fas",
    },
    {
        label: "T",
        value: "t",
        type: "fas",
    },
    {
        label: "Table",
        value: "table",
        type: "fas",
    },
    {
        label: "Table Cells",
        value: "table-cells",
        type: "fas",
    },
    {
        label: "Table Cells Large",
        value: "table-cells-large",
        type: "fas",
    },
    {
        label: "Table Columns",
        value: "table-columns",
        type: "fas",
    },
    {
        label: "Table List",
        value: "table-list",
        type: "fas",
    },
    {
        label: "Tablet Button",
        value: "tablet-button",
        type: "fas",
    },
    {
        label: "Table Tennis Paddle Ball",
        value: "table-tennis-paddle-ball",
        type: "fas",
    },
    {
        label: "Tablets",
        value: "tablets",
        type: "fas",
    },
    {
        label: "Tablet Screen Button",
        value: "tablet-screen-button",
        type: "fas",
    },
    {
        label: "Tachograph Digital",
        value: "tachograph-digital",
        type: "fas",
    },
    {
        label: "Tag",
        value: "tag",
        type: "fas",
    },
    {
        label: "Tags",
        value: "tags",
        type: "fas",
    },
    {
        label: "Tape",
        value: "tape",
        type: "fas",
    },
    {
        label: "Taxi",
        value: "taxi",
        type: "fas",
    },
    {
        label: "Teeth",
        value: "teeth",
        type: "fas",
    },
    {
        label: "Teeth Open",
        value: "teeth-open",
        type: "fas",
    },
    {
        label: "Temperature Empty",
        value: "temperature-empty",
        type: "fas",
    },
    {
        label: "Temperature Full",
        value: "temperature-full",
        type: "fas",
    },
    {
        label: "Temperature Half",
        value: "temperature-half",
        type: "fas",
    },
    {
        label: "Temperature High",
        value: "temperature-high",
        type: "fas",
    },
    {
        label: "Temperature Low",
        value: "temperature-low",
        type: "fas",
    },
    {
        label: "Temperature Quarter",
        value: "temperature-quarter",
        type: "fas",
    },
    {
        label: "Temperature Three Quarters",
        value: "temperature-three-quarters",
        type: "fas",
    },
    {
        label: "Tenge Sign",
        value: "tenge-sign",
        type: "fas",
    },
    {
        label: "Terminal",
        value: "terminal",
        type: "fas",
    },
    {
        label: "Text Height",
        value: "text-height",
        type: "fas",
    },
    {
        label: "Text Slash",
        value: "text-slash",
        type: "fas",
    },
    {
        label: "Text Width",
        value: "text-width",
        type: "fas",
    },
    {
        label: "Thermometer",
        value: "thermometer",
        type: "fas",
    },
    {
        label: "Thumbtack",
        value: "thumbtack",
        type: "fas",
    },
    {
        label: "Ticket",
        value: "ticket",
        type: "fas",
    },
    {
        label: "Ticket Simple",
        value: "ticket-simple",
        type: "fas",
    },
    {
        label: "Timeline",
        value: "timeline",
        type: "fas",
    },
    {
        label: "Toggle Off",
        value: "toggle-off",
        type: "fas",
    },
    {
        label: "Toggle On",
        value: "toggle-on",
        type: "fas",
    },
    {
        label: "Toilet",
        value: "toilet",
        type: "fas",
    },
    {
        label: "Toilet Paper",
        value: "toilet-paper",
        type: "fas",
    },
    {
        label: "Toilet Paper Slash",
        value: "toilet-paper-slash",
        type: "fas",
    },
    {
        label: "Toolbox",
        value: "toolbox",
        type: "fas",
    },
    {
        label: "Tooth",
        value: "tooth",
        type: "fas",
    },
    {
        label: "Torii Gate",
        value: "torii-gate",
        type: "fas",
    },
    {
        label: "Tower Broadcast",
        value: "tower-broadcast",
        type: "fas",
    },
    {
        label: "Tractor",
        value: "tractor",
        type: "fas",
    },
    {
        label: "Trademark",
        value: "trademark",
        type: "fas",
    },
    {
        label: "Traffic Light",
        value: "traffic-light",
        type: "fas",
    },
    {
        label: "Trailer",
        value: "trailer",
        type: "fas",
    },
    {
        label: "Train",
        value: "train",
        type: "fas",
    },
    {
        label: "Train Subway",
        value: "train-subway",
        type: "fas",
    },
    {
        label: "Train Tram",
        value: "train-tram",
        type: "fas",
    },
    {
        label: "Transgender",
        value: "transgender",
        type: "fas",
    },
    {
        label: "Trash",
        value: "trash",
        type: "fas",
    },
    {
        label: "Trash Arrow Up",
        value: "trash-arrow-up",
        type: "fas",
    },
    {
        label: "Trash Can Arrow Up",
        value: "trash-can-arrow-up",
        type: "fas",
    },
    {
        label: "Tree",
        value: "tree",
        type: "fas",
    },
    {
        label: "Triangle Exclamation",
        value: "triangle-exclamation",
        type: "fas",
    },
    {
        label: "Trophy",
        value: "trophy",
        type: "fas",
    },
    {
        label: "Truck",
        value: "truck",
        type: "fas",
    },
    {
        label: "Truck Fast",
        value: "truck-fast",
        type: "fas",
    },
    {
        label: "Truck Medical",
        value: "truck-medical",
        type: "fas",
    },
    {
        label: "Truck Monster",
        value: "truck-monster",
        type: "fas",
    },
    {
        label: "Truck Moving",
        value: "truck-moving",
        type: "fas",
    },
    {
        label: "Truck Pickup",
        value: "truck-pickup",
        type: "fas",
    },
    {
        label: "Truck Ramp Box",
        value: "truck-ramp-box",
        type: "fas",
    },
    {
        label: "Tty",
        value: "tty",
        type: "fas",
    },
    {
        label: "Turkish Lira Sign",
        value: "turkish-lira-sign",
        type: "fas",
    },
    {
        label: "Turn Down",
        value: "turn-down",
        type: "fas",
    },
    {
        label: "Turn Up",
        value: "turn-up",
        type: "fas",
    },
    {
        label: "Tv",
        value: "tv",
        type: "fas",
    },
    {
        label: "U",
        value: "u",
        type: "fas",
    },
    {
        label: "Umbrella",
        value: "umbrella",
        type: "fas",
    },
    {
        label: "Umbrella Beach",
        value: "umbrella-beach",
        type: "fas",
    },
    {
        label: "Underline",
        value: "underline",
        type: "fas",
    },
    {
        label: "Universal Access",
        value: "universal-access",
        type: "fas",
    },
    {
        label: "Unlock",
        value: "unlock",
        type: "fas",
    },
    {
        label: "Unlock Keyhole",
        value: "unlock-keyhole",
        type: "fas",
    },
    {
        label: "Up Down",
        value: "up-down",
        type: "fas",
    },
    {
        label: "Up Down Left Right",
        value: "up-down-left-right",
        type: "fas",
    },
    {
        label: "Upload",
        value: "upload",
        type: "fas",
    },
    {
        label: "Up Long",
        value: "up-long",
        type: "fas",
    },
    {
        label: "Up Right And Down Left From Center",
        value: "up-right-and-down-left-from-center",
        type: "fas",
    },
    {
        label: "Up Right From Square",
        value: "up-right-from-square",
        type: "fas",
    },
    {
        label: "User Astronaut",
        value: "user-astronaut",
        type: "fas",
    },
    {
        label: "User Check",
        value: "user-check",
        type: "fas",
    },
    {
        label: "User Clock",
        value: "user-clock",
        type: "fas",
    },
    {
        label: "User Doctor",
        value: "user-doctor",
        type: "fas",
    },
    {
        label: "User Gear",
        value: "user-gear",
        type: "fas",
    },
    {
        label: "User Graduate",
        value: "user-graduate",
        type: "fas",
    },
    {
        label: "User Group",
        value: "user-group",
        type: "fas",
    },
    {
        label: "User Injured",
        value: "user-injured",
        type: "fas",
    },
    {
        label: "User Large",
        value: "user-large",
        type: "fas",
    },
    {
        label: "User Large Slash",
        value: "user-large-slash",
        type: "fas",
    },
    {
        label: "User Lock",
        value: "user-lock",
        type: "fas",
    },
    {
        label: "User Minus",
        value: "user-minus",
        type: "fas",
    },
    {
        label: "User Ninja",
        value: "user-ninja",
        type: "fas",
    },
    {
        label: "User Nurse",
        value: "user-nurse",
        type: "fas",
    },
    {
        label: "User Pen",
        value: "user-pen",
        type: "fas",
    },
    {
        label: "User Plus",
        value: "user-plus",
        type: "fas",
    },
    {
        label: "Users",
        value: "users",
        type: "fas",
    },
    {
        label: "User Secret",
        value: "user-secret",
        type: "fas",
    },
    {
        label: "Users Gear",
        value: "users-gear",
        type: "fas",
    },
    {
        label: "User Shield",
        value: "user-shield",
        type: "fas",
    },
    {
        label: "User Slash",
        value: "user-slash",
        type: "fas",
    },
    {
        label: "Users Slash",
        value: "users-slash",
        type: "fas",
    },
    {
        label: "User Tag",
        value: "user-tag",
        type: "fas",
    },
    {
        label: "User Tie",
        value: "user-tie",
        type: "fas",
    },
    {
        label: "User Xmark",
        value: "user-xmark",
        type: "fas",
    },
    {
        label: "Utensils",
        value: "utensils",
        type: "fas",
    },
    {
        label: "V",
        value: "v",
        type: "fas",
    },
    {
        label: "Van Shuttle",
        value: "van-shuttle",
        type: "fas",
    },
    {
        label: "Vault",
        value: "vault",
        type: "fas",
    },
    {
        label: "Vector Square",
        value: "vector-square",
        type: "fas",
    },
    {
        label: "Venus",
        value: "venus",
        type: "fas",
    },
    {
        label: "Venus Double",
        value: "venus-double",
        type: "fas",
    },
    {
        label: "Venus Mars",
        value: "venus-mars",
        type: "fas",
    },
    {
        label: "Vest",
        value: "vest",
        type: "fas",
    },
    {
        label: "Vest Patches",
        value: "vest-patches",
        type: "fas",
    },
    {
        label: "Vial",
        value: "vial",
        type: "fas",
    },
    {
        label: "Vials",
        value: "vials",
        type: "fas",
    },
    {
        label: "Video",
        value: "video",
        type: "fas",
    },
    {
        label: "Video Slash",
        value: "video-slash",
        type: "fas",
    },
    {
        label: "Vihara",
        value: "vihara",
        type: "fas",
    },
    {
        label: "Virus",
        value: "virus",
        type: "fas",
    },
    {
        label: "Viruses",
        value: "viruses",
        type: "fas",
    },
    {
        label: "Virus Slash",
        value: "virus-slash",
        type: "fas",
    },
    {
        label: "Voicemail",
        value: "voicemail",
        type: "fas",
    },
    {
        label: "Volleyball",
        value: "volleyball",
        type: "fas",
    },
    {
        label: "Volume High",
        value: "volume-high",
        type: "fas",
    },
    {
        label: "Volume Low",
        value: "volume-low",
        type: "fas",
    },
    {
        label: "Volume Off",
        value: "volume-off",
        type: "fas",
    },
    {
        label: "Volume Xmark",
        value: "volume-xmark",
        type: "fas",
    },
    {
        label: "Vr Cardboard",
        value: "vr-cardboard",
        type: "fas",
    },
    {
        label: "W",
        value: "w",
        type: "fas",
    },
    {
        label: "Wallet",
        value: "wallet",
        type: "fas",
    },
    {
        label: "Wand Magic",
        value: "wand-magic",
        type: "fas",
    },
    {
        label: "Wand Magic Sparkles",
        value: "wand-magic-sparkles",
        type: "fas",
    },
    {
        label: "Warehouse",
        value: "warehouse",
        type: "fas",
    },
    {
        label: "Water",
        value: "water",
        type: "fas",
    },
    {
        label: "Water Ladder",
        value: "water-ladder",
        type: "fas",
    },
    {
        label: "Wave Square",
        value: "wave-square",
        type: "fas",
    },
    {
        label: "Weight Hanging",
        value: "weight-hanging",
        type: "fas",
    },
    {
        label: "Weight Scale",
        value: "weight-scale",
        type: "fas",
    },
    {
        label: "Wheelchair",
        value: "wheelchair",
        type: "fas",
    },
    {
        label: "Whiskey Glass",
        value: "whiskey-glass",
        type: "fas",
    },
    {
        label: "Wifi",
        value: "wifi",
        type: "fas",
    },
    {
        label: "Wind",
        value: "wind",
        type: "fas",
    },
    {
        label: "Wine Bottle",
        value: "wine-bottle",
        type: "fas",
    },
    {
        label: "Wine Glass",
        value: "wine-glass",
        type: "fas",
    },
    {
        label: "Wine Glass Empty",
        value: "wine-glass-empty",
        type: "fas",
    },
    {
        label: "Won Sign",
        value: "won-sign",
        type: "fas",
    },
    {
        label: "Wrench",
        value: "wrench",
        type: "fas",
    },
    {
        label: "X",
        value: "x",
        type: "fas",
    },
    {
        label: "Xmark",
        value: "xmark",
        type: "fas",
    },
    {
        label: "X Ray",
        value: "x-ray",
        type: "fas",
    },
    {
        label: "Y",
        value: "y",
        type: "fas",
    },
    {
        label: "Yen Sign",
        value: "yen-sign",
        type: "fas",
    },
    {
        label: "Yin Yang",
        value: "yin-yang",
        type: "fas",
    },
    {
        label: "Z",
        value: "z",
        type: "fas",
    },
];
